import Pageheader from 'components/Pageheader'
import ModalContext from 'contexts/ModalContext';
import React, { useEffect, useState, useContext } from 'react';
import { Helmet } from "react-helmet";
import { useSearchParams } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import { GetPromotionDetails } from 'services/Api/Module/Promotion';
import useProfileStore from 'services/store/ProfileModule';
import moment from 'moment';
import BottomAction2 from 'components/BottomAction2';
import useTranslations from 'i18n/useTranslations';
import PullToRefresh from 'components/pullToRefresh/PullToRefresh';
import { isDisabled } from '@testing-library/user-event/dist/utils';
import { GetCustomerProfile } from 'services/Api/Module/Customer';

const PromotionDetail = () => {
  const [searchParams,setSearchParams] = useSearchParams();
  const [topProfile, setTopProfile] = useState();
  
  const promotionId = searchParams.get('promotionId');
  const brandId = searchParams.get('restaurantId');
  const navigate = useNavigate();
  const { mAlert } = useContext(ModalContext);
  const [promotion, setPromotion] = useState();
  const [isConditionOpened, setIsConditionOpened] = useState(true);
  const profile = useProfileStore();
  const [refreshing, setRefreshing] = useState(false)
  const { lang } = useTranslations(); // สำหรับเปลี่ยนภาษา
  const { t } = useTranslations();
  const [isButtonDisabled, setIsButtonDisabled] = useState(false);

  const fetchGetPromotion = async (payload) => {
    try {
      const response = await GetPromotionDetails({ params: payload });
      const resData = response?.data;
      if (resData.resultCode === 20000) {
        setPromotion(resData.resultData);
      } else {
        mAlert.info({
          title: "ไม่พบ promotion",
          subTitle: "ไม่พบ promotion",
          content: "",
          onClose: () => { },
        });
      }
      setRefreshing(false)
    } catch (err) {
      setRefreshing(false)
      console.log('err ', err);
      mAlert.info({
        title: "แจ้งเตือน",
        subTitle: "มีบางอย่างผิดพลาด",
        content: "",
        onClose: () => { },
      });
    }
  };
  const fetchGetProfile = async (payload) => {
    try {
        const response = await GetCustomerProfile({ params: payload });
        const resData = response?.data;
        setTopProfile(resData?.resultData)
        setRefreshing(false)
        return resData?.resultData;
    } catch (err) {
        console.log('err ', err);
        setRefreshing(false)
        mAlert.info({
            title: "แจ้งเตือน",
            subTitle: "มีบางอย่างผิดพลาด",
            content: "",
            onClose: () => { },
        });
    }
};
  useEffect(() => {
    onLoad()
  }, [profile]);
  useEffect(() => {
    let payload = {
      // customerId: topProfile?.id,
      // customerId: profile?.customerProfile.id,
      promotionId: promotionId,
    }
    if (topProfile?.id) {
      fetchGetPromotion(payload);
    }
  },[topProfile])

  const handleBack = () => {
    navigate(`/coupon-all?restaurantId=${brandId}`)
  }
  const formatDate = (date,lang) => {
    if (lang === 'th') {
      // return date
      return moment(date).locale('th').format('D MMM YYYY'); // ตัวอย่าง: 1 ก.ค. 2024
    } else {
      return moment(date).locale('en').format('D MMM YYYY'); // ตัวอย่าง: 1 Jul 2024
    }
  };
  const toggleCondition = () => {
    setIsConditionOpened(!isConditionOpened);
  }
  const handleRefresh = () => {
    setRefreshing(true)
    onLoad();
  }
  const onLoad = async () => {
    const payload = {
      lineUid: profile?.lineUid
    };
    fetchGetProfile(payload)
    }
  return (
    <>
      <PullToRefresh
        refreshing={refreshing}
        onRefresh={handleRefresh}
      >
        <Helmet>
          <title>IMPACT Family</title>
          <meta name="title" content="Impact Family" />
          <meta name="description" content="Impact Family" />
          <meta name="keyword" content="" />
          <meta property="og:title" content="Impact Family" />
          <meta property="og:description" content="Impact Family" />
          <meta property="og:image" content="" />
          <meta property="og:url" content="" />
          <meta property="og:type" content="website" />
          <meta property="og:site_name" content="Impact Family" />
        </Helmet>
        <div id="pagePromotion-details">
          <Pageheader pagename={t.promotionDetail.header} onClick={handleBack} />

          <main id="top">
            <div className="wrapContent">

            <section id="pDetailsPromotion">
              <div class="bPromotionImg">
                <div class="bPic">
                  {/* <img src="https://dummyimage.com/342x180/667085/fff" alt=""/> */}
                  <img src={promotion?.img}  alt="" />
                </div>
              </div>
              <div class="bDetailsPromotion">
                <div class="bDetails">
                  <h2>{promotion?.promotionName}</h2>
                </div>
                <div class="bDate">
                <p>
                    {formatDate(promotion?.startDate,lang)} - {formatDate(promotion?.endDate,lang)}
                  </p>
                </div>

              </div>
            </section>
            <section id="pCondition">
            <div class="bCondition">
              <div class="bAccord">
                <div className={`btnAccord ${isConditionOpened ? 'opened' : ''}`} onClick={toggleCondition}>{t.promotionDetail.details}</div>
                    {isConditionOpened && (
                      <div className="contentAccord">
                        <div
                          className="bContent danger"
                          dangerouslySetInnerHTML={{
                            __html: `
                              ${promotion?.promotionDetail || ''}
                              <br /><br />
                              <hr />
                              ${t.promotionDetail.morepromotion} : 
                              <br />
                              <a href="${promotion?.promotionUrl || '#'}" target="_blank" rel="noopener noreferrer">
                                ${promotion?.promotionUrl || ''}
                              </a>
                            `
                          }}
                        />
                      </div>
                    )}
              </div>
            </div>
          </section>

              {/* Modal */}

            </div>
          </main>

        </div>
      </PullToRefresh>
    </>
  )
}

export default PromotionDetail